import { allModelsSelector } from 'common-src/utils/selectorUtils';

export const getPatientSurgicalHistory = (state, patientId) =>
  allModelsSelector(state, 'PatientSurgicalHistory', (s) => s.patientId === patientId);
